export default "__VITE_ASSET__421752a6__"